import { render, staticRenderFns } from "./ObjektiCard2Tab-8-Beleske.vue?vue&type=template&id=0dc541ad&scoped=true&"
import script from "./ObjektiCard2Tab-8-Beleske.vue?vue&type=script&lang=ts&"
export * from "./ObjektiCard2Tab-8-Beleske.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc541ad",
  null
  
)

export default component.exports